import { graphql, Link } from 'gatsby'
import React from 'react'
import get from 'lodash/get'

import Meta from 'components/meta'
import Layout from 'components/layout'

const SiteMapPage = ({ data, location }) => {
  return (
    <Layout location={location}>
      <Meta
        site={get(data, 'contentfulPagesSeo')}
      />
      <div className="wrapper inner-page">
        <div className="boxed">
          <div
            className="page-banner masked parallax-inner parallax-section sitemap-bnr"
            data-parallax="1"
          >
            <div className="inner-continer">
              <div className="row">
                <div className="col-md-10 col-lg-6 pd-0">
                  <h1 className="display-1 text-white">
                    Sitemap
                  </h1>
                  {/* <div className="title-info text-white">
                    Have a Question about infinity Energy?{' '}
                  </div>
                  <div className="">
                    <button
                      type="submit"
                      className="rounded btn-border btn text-white"
                    >
                      <Link className="link-btn text-white" to="/contact">
                        Contact Us
                      </Link>
                    </button>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-content page-content-sitemap">
          <div className="row-conteiner">
            <div className="boxed row">
              <div className="col-md-12 col-sm-12 text-center">
                <div className="inner-title delay-1 transform">
                  <h2 className="ttl-mr mb-3">
                    Site <span className="infity-color">Map</span>
                  </h2>
                  {/* <h4 className="sub-heading"></h4> */}
                </div>
              </div>
            </div>
          </div>
          <div className="sitemap-content container mb-4">
            <div className="row">
              <div className="col-md-4">
                <div className="sitemap-title mb-2">
                  <h3 className="ttl-mr pb-2 border-bottom">Company</h3>
                </div>
                <div className="sitemap-url">
                  <Link to="/about" className="d-flex flex-column page-url">
                    <h5 className="my-0">About Us</h5>
                    <span className="">At Infinity Energy, we exist to power you</span>
                  </Link>
                  <Link to="/career" className="d-flex flex-column page-url">
                    <h5 className="my-0">Careers</h5>
                    <span>Start your career today with Infinity Energy</span>
                  </Link>
                  <Link to="/plan" className="d-flex flex-column page-url">
                    <h5 className="my-0">Solar Plans</h5>
                    <span className="">
                      Find out which plan works best for you
                    </span>
                  </Link>
                  <Link to="/contact" className="d-flex flex-column page-url">
                    <h5 className="my-0">Contact Us</h5>
                    <span className="">Let's get in touch</span>
                  </Link>
                </div>
              </div>
              <div className="col-md-4">
                <div className="sitemap-title mb-2">
                  <h3 className="ttl-mr pb-2 border-bottom">Products</h3>
                </div>
                <div className="sitemap-url">
                  <Link to="/solar" className="d-flex flex-column page-url">
                    <h5 className="my-0">Solar</h5>
                    <span className="">Infinity Energy provides you intelligent energy solutions for your home.</span>
                  </Link>
                  <Link to="/infinity-plus" className="d-flex flex-column page-url">
                    <h5 className="my-0">Infinity Plus</h5>
                    <span className="">Infinity is even better together</span>
                  </Link>
                  <Link to="/battery" className="d-flex flex-column page-url">
                    <h5 className="my-0">Battery</h5>
                    <span className="">Optimize your energy savings and be prepared for emergencies.</span>
                  </Link>
                  <Link to="/roofing" className="d-flex flex-column page-url">
                    <h5 className="my-0">Roofing</h5>
                    <span className="">Get A Roofing Estimate In Few Seconds
                    </span>
                  </Link>
                </div>
              </div>
              <div className="col-md-4">
                <div className="sitemap-title mb-2">
                  <h3 className="ttl-mr pb-2 border-bottom">Support</h3>
                </div>
                <div className="sitemap-url">
                  <Link to="/referral" className="d-flex flex-column page-url">
                    <h5 className="my-0">Refer A Friend</h5>
                    <span className="">Share your friends and be Rewarded</span>
                  </Link>
                  <Link to="/faq" className="d-flex flex-column page-url">
                    <h5 className="my-0">Faq's</h5>
                    <span className="">Frequently asked questions</span>
                  </Link>
                  <Link to="/privacy-policy"
                    className="d-flex flex-column page-url">
                    <h5 className="my-0">Privacy Policy</h5>
                    <span className="">Information Collection, Use, and Sharing</span>
                  </Link>                  
                  <Link to="/blog" className="d-flex flex-column page-url">
                    <h5 className="my-0">Blog</h5>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="empty-space col-xs-b35 col-md-b70"></div>
        </div>
      </div>
    </Layout>
  )
}

export default SiteMapPage

export const query = graphql`
  {
    contentfulPagesSeo(pageName: {eq: "Sitemap"}) {
      pageTitle
      pageName
      otherScripts {
        otherScripts
      }
      otherMetaTags {
        otherMetaTags
      }
      metaTagUrl
      metaTagTitle
      metaTagDescription
    }
  }
`
